import { Typography } from '@mui/material';

export interface BulletItemProps {
  children: React.ReactNode;
}

export const BulletItem: React.FC<BulletItemProps> = ({ children }) => (
  <Typography fontSize="inherit">• {children}</Typography>
);
